/**
 * @purpose: menampilkan BAGGING-VIEW untuk monitoring per periode dan preview cetak per batch.
 * @called_by: views/app_manifest/manifest_bagging_view.html.
 * @deps: urlServices, toaster, _API_URL, $window.
 * @public: controller AngularJS baggingViewCtrl.
 * @side_effects: memanggil API daftar bagging berdasarkan periode dan membuka preview detail bagging di tab baru.
 */
app.controller('baggingViewCtrl', ['$scope', 'urlServices', 'toaster', '_API_URL', '$window', 'modalFactory', function ($scope, urlServices, toaster, _API_URL, $window, modalFactory) {
    var apiBase = 'api/bagging-entry';
    var defaultStartDate = moment().subtract(1, 'month').format('YYYY-MM-DD');
    var defaultEndDate = moment().format('YYYY-MM-DD');

    function normalizeTextValue(value) {
        if (value === undefined || value === null) {
            return '';
        }

        return String(value).trim();
    }

    $scope.loading = false;
    $scope.viewFilter = {
        perTgl: {
            startDate: moment().subtract(1, 'month'),
            endDate: moment()
        },
        term: '',
        limit: 20,
        pg: 1
    };
    $scope.baggingList = {
        records: 0,
        page: 1,
        limit: 20,
        pages: 1,
        data: []
    };

    function normalizeError(error) {
        if (!error) {
            return 'Error tidak terdeteksi';
        }
        if (error.err) {
            return error.err;
        }
        if (error.message) {
            return error.message;
        }
        if (error.data && error.data.err) {
            return error.data.err;
        }
        return String(error);
    }

    function normalizeDateText(value) {
        return moment(value).format('YYYY-MM-DD');
    }

    function buildListQuery(targetPage) {
        var query = [
            'startDate=' + encodeURIComponent(normalizeDateText($scope.viewFilter.perTgl.startDate)),
            'endDate=' + encodeURIComponent(normalizeDateText($scope.viewFilter.perTgl.endDate)),
            'limit=' + encodeURIComponent($scope.viewFilter.limit || 20),
            'pg=' + encodeURIComponent(targetPage || 1)
        ];
        var term = normalizeTextValue($scope.viewFilter.term);

        if (term) {
            query.push('term=' + encodeURIComponent(term));
        }

        return query.join('&');
    }

    function buildExportUrl() {
        var query = [
            'reportType=summary',
            'startDate=' + encodeURIComponent(normalizeDateText($scope.viewFilter.perTgl.startDate)),
            'endDate=' + encodeURIComponent(normalizeDateText($scope.viewFilter.perTgl.endDate))
        ];
        var term = normalizeTextValue($scope.viewFilter.term);

        if (term) {
            query.push('term=' + encodeURIComponent(term));
        }

        return _API_URL + 'bagging-entry/report-export?' + query.join('&');
    }

    function openPrintPreview(row) {
        var manifestDate = row && row.manifest_date ? moment(row.manifest_date).format('YYYY-MM-DD') : normalizeDateText($scope.viewFilter.perTgl.startDate);

        if (!row || !row.bag_id) {
            return toaster.pop('warning', 'BAGGING-VIEW', 'Nomor bagging tidak ditemukan');
        }

        return $window.open(_API_URL + 'bagging-print-preview?reportType=detail&source=view&returnUrl=' + encodeURIComponent('/bagging-view') + '&bagIds=' + encodeURIComponent(row.bag_id) + '&startDate=' + encodeURIComponent(manifestDate) + '&endDate=' + encodeURIComponent(manifestDate), '_blank');
    }

    function loadBaggingList(page) {
        var targetPage = page || $scope.viewFilter.pg || 1;

        $scope.loading = true;
        $scope.viewFilter.pg = targetPage;

        return urlServices.ambilData(apiBase + '?' + buildListQuery(targetPage), {}, function (err, result) {
            $scope.loading = false;
            if (err) {
                $scope.baggingList = {
                    records: 0,
                    page: 1,
                    limit: $scope.viewFilter.limit || 20,
                    pages: 1,
                    data: []
                };
                return toaster.pop('error', 'BAGGING-VIEW', normalizeError(err));
            }

            $scope.baggingList = result || {
                records: 0,
                page: targetPage,
                limit: $scope.viewFilter.limit || 20,
                pages: 1,
                data: []
            };
            $scope.viewFilter.pg = $scope.baggingList.page || targetPage;
        });
    }

    $scope.loadBaggingList = function (page) {
        return loadBaggingList(page);
    };

    $scope.$watch('viewFilter.perTgl', function (newDate) {
        if (newDate) {
            $scope.loadBaggingList(1);
        }
    }, false);

    $scope.resetFilters = function () {
        $scope.viewFilter = {
            startDate: defaultStartDate,
            endDate: defaultEndDate,
            term: '',
            limit: 20,
            pg: 1
        };
        return loadBaggingList(1);
    };

    $scope.createBagging = function () {
        return $window.location.href = '/bagging';
    };

    $scope.exportExcel = function () {
        return $window.open(buildExportUrl(), '_blank');
    };

    $scope.previewBaggingDetail = function (row) {
        return openPrintPreview(row);
    };

    $scope.showBaggingDetail = function (row) {
        if (!row || !row.bag_id) {
            return toaster.pop('warning', 'BAGGING-VIEW', 'Nomor bagging tidak ditemukan');
        }

        return modalFactory.open('lg', 'modal.bagging.detail.html', 'modalBaggingDetailCtrl', {
            bagId: row.bag_id
        });
    };

    $scope.editBagging = function (row) {
        if (!row || !row.bag_id) {
            return toaster.pop('warning', 'BAGGING-VIEW', 'Nomor bagging tidak ditemukan');
        }
        if (row.has_manifested_awb) {
            return toaster.pop('warning', 'BAGGING-VIEW', 'Bagging tidak bisa diedit karena ada AWB yang sudah termanifest');
        }

        return $window.location.href = '/bagging?bagId=' + encodeURIComponent(row.bag_id);
    };

    $scope.deleteBagging = function (row) {
        if (!row || !row.bag_id) {
            return toaster.pop('warning', 'BAGGING-VIEW', 'Nomor bagging tidak ditemukan');
        }
        if (row.has_manifested_awb) {
            return toaster.pop('warning', 'BAGGING-VIEW', 'Bagging tidak bisa dihapus karena ada AWB yang sudah termanifest');
        }

        if (!$window.confirm('Hapus bagging ' + row.bag_id + ' beserta semua detail AWB di dalamnya?')) {
            return true;
        }

        $scope.loading = true;
        return urlServices.hapusData(apiBase + '/' + encodeURIComponent(row.bag_id), {}, function (err) {
            $scope.loading = false;
            if (err) {
                return toaster.pop('error', 'BAGGING-VIEW', normalizeError(err));
            }

            toaster.pop('success', 'BAGGING-VIEW', 'Bagging ' + row.bag_id + ' berhasil dihapus');
            return loadBaggingList($scope.viewFilter.pg || 1);
        });
    };

    loadBaggingList(1);
}]);
